// extracted by mini-css-extract-plugin
module.exports = {"DefaultTheme__overlay___3AceM":"DefaultTheme__overlay___3AceM","DefaultTheme__modal___21WiE":"DefaultTheme__modal___21WiE"};